<template>
  <div class="user-card">
    <div class="user-info">
      <el-avatar :size="50" :src="userData.user_info.avatar || defaultAvatar"></el-avatar>
      <div class="user-details">
        <h3>{{ userData.user_info.user_name }}</h3>
        <p class="bio">{{ userData.user_info.bio || 'No bio yet' }}</p>
      </div>
    </div>
    <div class="user-actions">
      <el-button 
        type="primary" 
        size="small"
        @click="handleFollow"
        :loading="loading"
      >
        {{ isFollowing ? 'Unfollow' : 'Follow' }}
      </el-button>
      <el-button 
        type="success" 
        size="small"
        @click="handleMessage"
      >
        Message
      </el-button>
    </div>
  </div>
</template>

<script>
import { postRequest } from '@/apis/front'

export default {
  name: 'User',
  props: {
    userData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      isFollowing: false,
      defaultAvatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
    }
  },
  methods: {
    async handleFollow() {
      this.loading = true
      try {
        const response = await postRequest('followUser', {
          user_id: this.$store.state.user_id,
          target_user_id: (this.userData.user_info._id.$oid || this.userData.user_info._id.$id)
        })
        
        if (response.data.code === 0) {
          this.isFollowing = !this.isFollowing
          this.$message.success(this.isFollowing ? 'Followed successfully' : 'Unfollowed successfully')
        } else {
          this.$message.error(response.data.msg || 'Operation failed')
        }
      } catch (error) {
        this.$message.error('Operation failed')
      } finally {
        this.loading = false
      }
    },
    handleMessage() {
      // TODO: Implement messaging functionality
      this.$message.info('Messaging feature coming soon!')
    }
  },
  async mounted() {
    // TODO: Check if current user is following this user
    // this.isFollowing = await checkFollowStatus((this.userData.user_info._id.$oid || this.userData.user_info._id.$id))
  }
}
</script>

<style scoped>
.user-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  transition: background-color 0.3s;
}

.user-card:hover {
  background-color: #f9f9f9;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 20px;
}

.user-details {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.user-details h3 {
  margin: 0;
  font-size: 16px;
}

.bio {
  margin: 0;
  color: #666;
  font-size: 14px;
}

.user-actions {
  display: flex;
  gap: 10px;
}
</style> 